/* ============================================================
   AŞKIM: Shop filters in the page
   Garment type, colour and sort act on the pieces already on the page,
   through AskimFilters.applyFilters, with no reload: arrow keys in a
   dropdown or through the colours just re-draw the grid. Choosing a
   collection goes to that collection's page.
   ============================================================ */
(function () {
  var bar = document.querySelector('[data-shop-filters]');
  var grid = document.querySelector('[data-shop-grid]');
  if (!bar || !window.AskimFilters) return;

  var nav = bar.querySelector('[data-collection-nav]');
  if (nav) nav.addEventListener('change', function () { location.assign(nav.value); });
  if (!grid) return;

  var items = [].slice.call(grid.querySelectorAll('.p-card')).map(function (el, i) {
    return {
      el: el,
      type: el.getAttribute('data-type') || '',
      colours: (el.getAttribute('data-colours') || '').split('|').filter(Boolean),
      price: parseInt(el.getAttribute('data-price'), 10) || 0,
      available: el.getAttribute('data-available') === 'true',
      index: i
    };
  });

  /* Each card carries its photographs in every colour (data-looks, from
     product-card.liquid). Picking a colour shows every piece in that colour
     and links it to that colour; All colours puts each card back the way
     the page drew it. */
  items.forEach(function (it) {
    try { it.looks = JSON.parse(it.el.getAttribute('data-looks') || '{}'); } catch (e) { it.looks = {}; }
    var img = it.el.querySelector('.p-card__media img:not(.img-b)');
    var imgB = it.el.querySelector('.p-card__media img.img-b');
    it.base = {
      url: it.el.getAttribute('href'),
      src: img ? img.getAttribute('src') : '',
      srcset: img ? img.getAttribute('srcset') : '',
      alt: img ? img.getAttribute('alt') : '',
      b: imgB ? imgB.getAttribute('src') : '',
      bset: imgB ? imgB.getAttribute('srcset') : ''
    };
  });

  function dress(it, colour) {
    var look = (colour !== 'all' && it.looks[colour]) || it.base;
    var img = it.el.querySelector('.p-card__media img:not(.img-b)');
    if (!img || !look.src) return;
    if (img.getAttribute('src') !== look.src) {
      img.setAttribute('srcset', look.srcset || '');
      img.setAttribute('src', look.src);
      img.setAttribute('alt', look.alt || '');
    }
    var imgB = it.el.querySelector('.p-card__media img.img-b');
    if (look.b) {
      if (!imgB) {
        imgB = document.createElement('img');
        imgB.className = 'img-b';
        imgB.alt = '';
        imgB.loading = 'lazy';
        imgB.setAttribute('sizes', img.getAttribute('sizes') || '');
        img.parentNode.insertBefore(imgB, img.nextSibling);
      }
      if (imgB.getAttribute('src') !== look.b) {
        imgB.setAttribute('srcset', look.bset || '');
        imgB.setAttribute('src', look.b);
      }
      imgB.style.display = '';
    } else if (imgB) {
      imgB.style.display = 'none';
    }
    if (look.url) it.el.setAttribute('href', look.url);
  }

  var typeSel = bar.querySelector('[data-filter-type]');
  var sortSel = bar.querySelector('[data-filter-sort]');
  var colourBtns = [].slice.call(bar.querySelectorAll('[data-colour-choice]'));
  var count = bar.querySelector('[data-shop-count]');
  var empty = document.querySelector('[data-filter-empty]');
  var clear = document.querySelector('[data-filter-clear]');
  var state = { type: 'all', colour: 'all', sort: 'featured' };

  function draw() {
    var shown = window.AskimFilters.applyFilters(items, state);
    items.forEach(function (it) { it.el.hidden = true; });
    shown.forEach(function (it) {
      dress(it, state.colour);
      it.el.hidden = false;
      it.el.classList.add('in');
      grid.appendChild(it.el);
    });
    if (count) count.textContent = shown.length + (shown.length === 1 ? ' piece' : ' pieces');
    grid.hidden = shown.length === 0;
    if (empty) empty.hidden = shown.length > 0;
  }

  function pickColour(value) {
    state.colour = value;
    colourBtns.forEach(function (b) {
      var on = b.getAttribute('data-colour-choice') === value;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  if (typeSel) typeSel.addEventListener('change', function () { state.type = typeSel.value; draw(); });
  if (sortSel) sortSel.addEventListener('change', function () { state.sort = sortSel.value; draw(); });
  colourBtns.forEach(function (b) {
    b.addEventListener('click', function () { pickColour(b.getAttribute('data-colour-choice')); draw(); });
  });
  if (clear) clear.addEventListener('click', function () {
    state = { type: 'all', colour: 'all', sort: state.sort };
    if (typeSel) typeSel.value = 'all';
    pickColour('all');
    draw();
    if (typeSel) typeSel.focus();
  });
})();
